import { Switch } from '@beeinventor/dasiot-react-component-lib';
import { styled } from '@mui/material';

const List = styled('ul')`
  padding: 0;
  & > li {
    display: flex;
    gap: 10px;
    align-items: center;
    list-style-type: none;
  }

  & > .text-field {
    margin-top: 10px;
  }
`;

interface PrivacyDataDialogContentProps {
  metadata: {
    [propertyName: string]: any;
  };
  onChange: (propertyName: string, value: any) => void;
}

const PrivacyDataDialogContent: React.FC<PrivacyDataDialogContentProps> = ({
  metadata,
  onChange,
}) => {
  return (
    <List>
      <li>
        <Switch
          checked={metadata['heatstroke']}
          onChange={(_, checked) => onChange('heatstroke', checked)}
        />
        <span>Heat Stroke</span>
      </li>
    </List>
  );
};

export default PrivacyDataDialogContent;
